// ------------------------------------------
// ローディング画面
// ------------------------------------------
$(function () {
  const LOADING_DURATION_MS = 2400;
  var webStorage = function () {
    const accessKey = 'access';
    const isIndex = document.body.classList.contains('template-index');
    const hasAccess = Boolean(sessionStorage.getItem(accessKey));
    const trackingParamPattern = /(?:[?&])(utm_[^=]*|gclid|fbclid|msclkid|yclid)=/i;
    const hasTrackingParams = trackingParamPattern.test(window.location.search);
    const shouldShowLoading = isIndex && !hasAccess && !hasTrackingParams;

    if (!shouldShowLoading) {
      $(".gradient").css({'background': 'rgb(var(--color-background))'});
      $(".gradient").css({'background': 'var(--gradient-background)'});
      $(".gradient").css({'background-attachment': 'fixed'});
      $(".header").css({'opacity': '1'});
      $("main").css({'opacity': '1'});
      document.documentElement.classList.remove('dt-loading');
      return;
    }

    /*初回アクセス時の処理*/
    sessionStorage.setItem(accessKey, 'true'); // sessionStorageにデータを保存
    // loadingアニメーションを表示
    $(".u-loading").addClass('is-active');
    $(".gradient").addClass('is-gradientLoading');
    $(".header").css({'opacity': '0'});
    $("main").css({'opacity': '0'});

    setTimeout(function () {
      // ローディングを数秒後に非表示にする
      $(".u-loading").removeClass('is-active');
      $(".u-loading").addClass('is-close');
      $(".header").addClass('is-headerLoading');
      $("main").addClass('is-mainLoading');
      $(".header").css({'opacity': '1'});
      $("main").css({'opacity': '1'});
      document.documentElement.classList.remove('dt-loading');
    }, LOADING_DURATION_MS); // ローディングを表示する時間
  }
  webStorage();
});

// ------------------------------------------
//Vegas全体の設定
// ------------------------------------------
let swipeOption = {
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 2300,
    disableOnInteraction: false
  },
  speed: 4000,
}
new Swiper('.fv-swiper-container', swipeOption);

// ------------------------------------------
// 商品スライダー
// ------------------------------------------
let productSwiper = {
  loop: true,
  centeredSlides: true,
  spaceBetween: 7,
  slidesPerView: 3.5,
  autoplay: {
    delay: 4500,
    disableOnInteraction: false,
  },
  speed: 2000,
  breakpoints: {
    // 1025px以上の場合
    1024: {
      slidesPerView: 1.5,
    },
  },
  on: {
    init: function() {
      this.lazy.loadInSlide(this.activeIndex - 1);
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
}
new Swiper('.product-swiper-container', productSwiper);

// ------------------------------------------
// 商品詳細フェードスライダー
// ------------------------------------------
let detailSwiper = {
  loop: true,
  effect: 'fade',
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 2000,
  navigation: {
    nextEl: ".detail-swiper-button-next",
    prevEl: ".detail-swiper-button-prev",
  },
  pagination: {
    el: '.detail-swiper-pagination',
    clickable: true,
  }
}
new Swiper('.detail-swiper-container', detailSwiper);

// ------------------------------------------
// 商品画面 商品画像スライダー
// ------------------------------------------
$(function() {
  var slider = ".slider1_2";
  var thumb = ".thumb1_2";
  var thumbitem = thumb + " .thumbnail-item";

  // サムネイル画像アイテムに data-index でindex番号を付与
  $(thumbitem).each(function(){ var index = $(thumbitem).index(this);
    $(this).attr("data-index",index);
  });
  // スライダー初期化後、カレントのサムネイル画像にクラス「thumbnail-current」を付ける
  $(slider).on('init',function(slick){
    var index = $(".slide-item.slick-slide.slick-current").attr("data-slick-index");
    $(thumbitem+'[data-index="'+index+'"]').addClass("thumbnail-current");
  });

  //サムネイル画像をクリックしたときにスライダー切り替え
  $(thumbitem).on('click',function(){
    var index = $(this).attr("data-index");
    $(slider).slick("slickGoTo",index,false);
  });

  //サムネイル画像をマウスオーバーした場合
  $(thumbitem).hover(function(){
    var index = $(this).attr("data-index");
    $(slider).slick("slickGoTo",index,false);
  });

  //サムネイルフォーカス
  $(slider).on('beforeChange',function(event,slick, currentSlide,nextSlide){
    $(thumbitem).each(function(){ $(this).removeClass("thumbnail-current");});
    $(thumbitem+'[data-index="'+nextSlide+'"]').addClass("thumbnail-current");
  });
  //スライダー設定
  $(slider).slick({
    autoplay: false,
    arrows: false,
    fade: true,
    infinite: true
  });
});


// ------------------------------------------
// スクロールで下からフェードイン
// ------------------------------------------
function pageStart(){
  $('.fadeUp').each(function(){
    var elemPos = $(this).offset().top;
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    if(scrollTop > elemPos - windowHeight + 50){
      $(this).addClass('scrollUp');
    }
  });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
  pageStart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
  pageStart();
});


// ------------------------------------------
// スクロールで下からフェードイン（グラデーション用）
// ------------------------------------------
function gradationPageStart(){
  $('.gradationFadeUp').each(function(){
    var gradationElemPos = $(this).offset().top;
    var gradationScrollTop = $(window).scrollTop();
    var gradationWindowHeight = $(window).height();

    if(gradationScrollTop > gradationElemPos - gradationWindowHeight + 50){
      $(this).addClass('gradationScrollUp');
    }
  });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
  gradationPageStart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
  gradationPageStart();
});


$(function(){
  // 🛑 2026/10/19: スマホのメニューの「見える／見えない（opacity）」と「位置（top）」をここでクリック回数で
  //    toggleClass('active') していたのを撤去した。<details> の open と回数がずれると（× を素早く 2 回押す／
  //    メニュー内のリンクでない所をタップしてから閉じる）、開いているのに透明になり「もう開けない」に見えた
  //    （本番で再現・daytune-claude/.claude/assets/site-nav-20260914/sp-close-cart-tab-20261019/reopen/findings_reopen.md）。
  //    今は CSS が Dawn の状態クラス .menu-opening（global.js の MenuDrawer が開く時に付け・閉じる時に即外す）で
  //    決める＝ assets/component-menu-drawer.css / assets/custom.css.liquid の `.menu-drawer-container.menu-opening > .menu-drawer`。
  //    クリック回数で状態を持つ処理をここに戻さないこと。

  // シーンスライダー
  $('.scene__slider__list').slick({
    autoplay: true,
    speed: 3000,
      dots: true,
    arrows: true,
      prevArrow: '<img src="//daytune.jp/cdn/shop/files/icon_arrow_next_darkgray.svg?v=1542499517535152852" class="slide-arrow prev-arrow" alt="前へ">',
    nextArrow: '<img src="//daytune.jp/cdn/shop/files/icon_arrow_next_darkgray.svg?v=1542499517535152852" class="slide-arrow next-arrow" alt="次へ">',
    centerMode: true,
    variableWidth: true,
    cssEase: 'ease'
  });

  // 最上部へ戻る
  var topBtn = $('#pageContents_goToTop_button');
  topBtn.click(function () {
    $('body,html').animate({ scrollTop: 0 }, 500);
    return false;
  });

  // アコーディオン
  $('.nav__item__title__icon').on('click', function() {
    var findElm = $(this).next(".products__nav");
    $(findElm).slideToggle();

      if($(this).hasClass('close')){
      $(this).removeClass('close');
    }else{
        $(this).addClass('close');
    }
  });

  // カーソル追従は assets/dt-stalker.js へ移した（2026/10/5）
});

// ------------------------------------------
// headerをスクロールすると、色が変わる
// ------------------------------------------
  $(window).on('scroll', function () {
      if ($('.header').hasClass('index_page')) {
        if ($('.header').height() < $(this).scrollTop()) {
            $('.header').addClass('change-color');
        } else {
            $('.header').removeClass('change-color');
        }
      }
  });


// ------------------------------------------
// headerのスマホアコーディオン
// ------------------------------------------
$(function() {
    // 🛑 2026/10/19: 開く演出のクラスを「クリック回数」でなく <details> の open に連動させる（上の .active と同じ不具合の予防）。
    //    付ける＝☰ を押した瞬間（捕捉段階・open が付く前に同期で。toggle のタスクを待つと 1 コマだけ項目が素で見えてから
    //    演出が始まりうる＝Opus レビュー P2-2）／外す＝閉じ終わった時（toggle・global.js が open を外す 400ms 後）。
    //    どちらも document の捕捉段階で受けて ID で絞る＝テーマエディタがヘッダーを描き直しても付け直しが要らない
    //    （sections/header.liquid の setHeaderHeight・assets/sp-nav-drawer.js と同じ形・Opus レビュー P2-1）。
    var DRAWER_ID = 'Details-menu-drawer-container';
    var setFadeUp = function (open) {
        var items = $(".menu-drawer .footer__nav__item");
        items.toggleClass("headerFadeUp", open);
        for (var i = 1; i <= 9; i++) {
            items.eq(i).toggleClass("headerFadeUpDelay-time" + (i + 1 < 10 ? "0" : "") + (i + 1), open);
        }
        $(".menu-drawer .footer__bland").toggleClass("headerFadeUp", open);
        $(".menu-drawer .footer__option").toggleClass("headerFadeUp", open);
    };
    document.addEventListener('click', function (event) {
        var summary = event.target && event.target.closest && event.target.closest('#' + DRAWER_ID + ' > summary');
        if (!summary) return;
        var drawer = summary.parentNode;
        // 閉じる途中（open は残っているが .menu-opening は外れている）の押下は global.js が「閉じる」として扱う＝付けない
        if (!drawer.open) setFadeUp(true);
    }, true);
    document.addEventListener('toggle', function (event) {
        var drawer = event.target;
        if (!drawer || drawer.id !== DRAWER_ID) return;
        setFadeUp(!!drawer.open);
    }, true);
    var initial = document.getElementById(DRAWER_ID);
    setFadeUp(!!(initial && initial.open));
});


// ------------------------------------------
// conceptセクション用
// ------------------------------------------
// if (window.matchMedia('(max-width: 1024px)').matches) {

//   gsap.fromTo('.concept__box__color',{
//     x:'0%'
//   },{
//     x:0,
//     scrollTrigger:{
//         trigger:'.concept__box__window',
//         start:'top -50%',
//         end:'top 100%',
//         // markers:true,
//         scrub:true,
//     }
//   })
  
//   gsap.fromTo('.concept__box__color',{
//     y:'-70%'
//   },{
//     y:'0%',
//     repeat: -1,
//     yoyo: true,
//     ease: 'power1.inOut',
//     duration:5,
//     scrollTrigger:{
//       trigger:'.concept__box__window',
//       start:'top 100%',
//       toggleActions: 'play pause resume reset',
//   }
//   });

// } else if (window.matchMedia('(min-width:1024px)').matches) {

//   gsap.fromTo('.concept__box__color',{
//     y:'0%'
//   },{
//     y:0,
//     scrollTrigger:{
//         trigger:'.concept__box__window',
//         start:'top -50%',
//         end:'top 100%',
//         // markers:true,
//         scrub:true,
//     }
//   })
  
//   gsap.fromTo('.concept__box__color',{
//     x:'0%'
//   },{
//     x:'-50%',
//     repeat: -1,
//     yoyo: true,
//     ease: 'power1.inOut',
//     duration:5,
//     scrollTrigger:{
//       trigger:'.concept__box__window',
//       start:'top 100%',
//       toggleActions: 'play pause resume reset',
//   }
//   });

// }


// ------------------------------------------
// Productsページ（コレクションページ）左側メニューアコーディオン（絞り込み検索）
// ------------------------------------------
$(function(){
  if(window.matchMedia('(max-width: 1024px)').matches) {
    $('.p-itemQueries__item__title').on('click', function() {
      var findItem = $(this).next(".p-itemQueries__item__list");
      $(findItem).slideToggle();

      if($(this).hasClass('open')){
        $(this).removeClass('open');
      }else{
        $(this).addClass('open');
      }
    });
  }else{
    $(".p-itemQueries__item__list").css("display", "block");
    $(".p-itemQueries__item__title").addClass("open");
    $(".p-itemQueries__item__title").on("click", function () {
      $(this).next().slideToggle(200);
      $(this).toggleClass("open", 200);
    });
  }

  var open = $('.modal-open'),
      close = $('.modal-close'),
      container = $('.modal-container');

    //開くボタンをクリックしたらモーダルを表示する
  open.on('click',function(){
      container.addClass('active');
      $(".p-itemQueries__item__list").css("display", "none");
      if($(".p-itemQueries__item__title").hasClass('open')){
        $(".p-itemQueries__item__title").removeClass('open');
      }
      $(".p-itemQueries__item").addClass("itemQueriesFadeUp");
      $(".p-itemQueries__item").eq(1).addClass("itemQueriesFadeUpDelay-time02");
      $(".p-itemQueries__item").eq(2).addClass("itemQueriesFadeUpDelay-time03");
      $(".p-itemQueries__item").eq(3).addClass("itemQueriesFadeUpDelay-time04");
      $(".p-itemQueries__item").eq(4).addClass("itemQueriesFadeUpDelay-time05");
      $(".p-itemQueries__item").eq(5).addClass("itemQueriesFadeUpDelay-time06");
      $(".p-itemQueries__item").eq(6).addClass("itemQueriesFadeUpDelay-time07");
      $(".p-itemQueryCheckbox").addClass("itemQueriesFadeUp");
      return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  close.on('click',function(){
      container.removeClass('active');
      $(".p-itemQueries__item").removeClass("itemQueriesFadeUp");
      $(".p-itemQueries__item").eq(1).removeClass("itemQueriesFadeUpDelay-time02");
      $(".p-itemQueries__item").eq(2).removeClass("itemQueriesFadeUpDelay-time03");
      $(".p-itemQueries__item").eq(3).removeClass("itemQueriesFadeUpDelay-time04");
      $(".p-itemQueries__item").eq(4).removeClass("itemQueriesFadeUpDelay-time05");
      $(".p-itemQueries__item").eq(5).removeClass("itemQueriesFadeUpDelay-time06");
      $(".p-itemQueries__item").eq(6).removeClass("itemQueriesFadeUpDelay-time07");
      $(".p-itemQueryCheckbox").removeClass("itemQueriesFadeUp");
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container.removeClass('active');
      }
    $(".p-itemQueries__item").removeClass("itemQueriesFadeUp");
    $(".p-itemQueries__item").eq(1).removeClass("itemQueriesFadeUpDelay-time02");
    $(".p-itemQueries__item").eq(2).removeClass("itemQueriesFadeUpDelay-time03");
    $(".p-itemQueries__item").eq(3).removeClass("itemQueriesFadeUpDelay-time04");
    $(".p-itemQueries__item").eq(4).removeClass("itemQueriesFadeUpDelay-time05");
    $(".p-itemQueries__item").eq(5).removeClass("itemQueriesFadeUpDelay-time06");
    $(".p-itemQueries__item").eq(6).removeClass("itemQueriesFadeUpDelay-time07");
    $(".p-itemQueryCheckbox").removeClass("itemQueriesFadeUp");
  });
  
  // 今いるページのメニューにクラス名追加
  $('.p-itemQueries__item__list__item a').each(function(){
    var $target = $(this).attr('href');
    var $target = decodeURI($target);
    var $target = $target.split('/');
    var $target = $target.slice(-1)[0];
    var $location = decodeURI(location.href).split('/');
    var $location = $location.slice(-1)[0];
    if($target === $location) {
      $(this).parents('.p-itemQueries__item__list').find('.p-itemQueries__item__list__item--top').removeClass('p-itemQueries__item__list__item--top');
      $(this).parent().addClass('is-current');
    }
  });
});



// ------------------------------------------
// TOPページFVアニメーション
// ------------------------------------------
// ロゴアニメーション
  var disp_fv_logo_obj　= function disp_fv_logo(){
    const ele = document.getElementById('p-top__eyecatch__logo');
    if(ele){
      ele.classList.add('is-show');      
    }
  }

//テキストアニメーション
  var disp_fv_text_obj = function disp_fv_text(){
    var ele_p_top__eyecatch__copy =  document.getElementById('p-top__eyecatch__copy');
    if(ele_p_top__eyecatch__copy){
        ele_p_top__eyecatch__copy.style.opacity ="1";
        var textWrapper = document.querySelectorAll('.js-animation');
        var textWrapper2 = document.querySelectorAll('.js-animation2');
        textWrapper.forEach((t) => (
            t.innerHTML = t.textContent.replace(/\S/g, "<span class='letter'>$&</span>"
            )
        ));
        textWrapper2.forEach((t) => (
            t.innerHTML = t.textContent.replace(/\S/g, "<span class='letter2'>$&</span>"
            )
        ));
        
        gsap.fromTo('.letter',{
          y:'1.5em',
        },{
          y:'0',
          stagger:0.05
        });
    
      gsap.fromTo('.letter2',{
        y:'1.5em',
      },{
        y:'0',
        delay:1,
        stagger:0.05
      });
    }
}

//ロゴとテキストの表示タイミング
if (sessionStorage.getItem("access")) {
  setTimeout( disp_fv_logo_obj , 1000);
  setTimeout( disp_fv_text_obj , 1200);
}else{
  setTimeout( disp_fv_logo_obj , 5000);
  setTimeout( disp_fv_text_obj , 5500);
}

// ------------------------------------------
// スムーススクロール
// ------------------------------------------
$(function () {
    // 別ページの場合は以下
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
      // アナウンスバー（別セクション・固定・ヘッダーの上）の高さも足す。無いページは 0
      // （メール・LINE の #アンカー付きリンクで着地した時に区画の上端が隠れていた＝2026/9/18 #20260904-マーケ-03）
      var headerHight = $('header').outerHeight() + ($('#shopify-section-announcement-bar').outerHeight() || 0) + 50;
      var target = $(urlHash);
      var position = target.offset().top - headerHight;
      $('body,html').stop().animate({scrollTop:position}, 600);
  }, 200);
}
});



// ------------------------------------------
// conceptページ
// ------------------------------------------

// テキストを１文字ずつ表示01

var container01 = $(".eachTextAnime01");
var content01 = container01.html();
var text01 = $.trim(content01);
var newHtml01 = "";

text01.split("").forEach(function(v) {
newHtml01 += '<span>' + v + '</span>';
});

container01.html(newHtml01);

var txtNum01 = 0;
container01.css({opacity: 1});
setInterval(function() {
  container01.find('span').eq(txtNum01).css({
    'opacity': '1',
    'top': '0'
  });
txtNum01++
}, 30);

// テキストを１文字ずつ表示02

var container02 = $(".eachTextAnime02");
var content02 = container02.html();
var text02 = $.trim(content02);
var newHtml02 = "";

text02.split("").forEach(function(v) {
newHtml02 += '<span>' + v + '</span>';
});

container02.html(newHtml02);

var txtNum02 = 0;
container02.css({opacity: 1});
setInterval(function() {
  container02.find('span').eq(txtNum02).css({
    'opacity': '1',
    'top': '0'
  });
txtNum02++
}, 40);


// グラデーション位置固定
/*
$(function(){

  $(window).on('load scroll', function(){
      var conceptFixedPosition = window.innerHeight + $(window).scrollTop(),
          conceptFixedHight = $('.conceptFixed__section').height();

     if(window.matchMedia('(min-width: 1023px)').matches) {

        if( conceptFixedPosition > conceptFixedHight ){
          $('.conceptFixed__window').addClass('conceptFixed__window--move');
        }else{
          $('.conceptFixed__window').removeClass('conceptFixed__window--move');
        }
      }

    });

});
*/

// コンセプト：グラデーション窓の「最後は一緒にスクロール」を制御

/*(function($){
  function updateConceptFixed(){
    if (!window.matchMedia('(min-width: 1025px)').matches) return;

    var $section = $('.conceptFixed__section');
    var $win     = $('.conceptFixed__window');
    var $stop    = $('.conceptFixed__stop');
    var $inner   = $('.conceptFixed__inner');
if ($section.length === 0 || $inner.length === 0 || $win.length === 0 || $stop.length === 0) return;

    // fixed時の窓の top（画面内）と高さ
    var fixedTop = parseFloat(getComputedStyle($win[0]).top) || 0;
    var winH     = $win.outerHeight();

    var scrollTop = $(window).scrollTop();

    // 「窓の下端」がページ上のどこにいるか
    var windowBottomY = scrollTop + fixedTop + winH;

    // stop（目印）のページ座標
    var stopY = $stop.offset().top;
    

    // 微調整：早めに動かしたいならマイナス、遅めならプラス
    var START_OFFSET_PX = 0;

    var shouldMove = windowBottomY >= (stopY + START_OFFSET_PX);

    if (shouldMove){
      // absoluteに切り替えても見えている位置が変わらないように、
      // セクション内のtop(px)を固定する
      var topInInner = (scrollTop + fixedTop) - $inner.offset().top;
if (topInInner < 0) topInInner = 0;

$win.addClass('conceptFixed__window--move');
$win[0].style.setProperty('--dt-move-top', topInInner + 'px');

    } else {
      $win.removeClass('conceptFixed__window--move');
      $win[0].style.removeProperty('--dt-move-top');
    }
  }

  $(window).on('load scroll resize', updateConceptFixed);
})(jQuery);
*/

(function($){
  function updateConceptFollow(){
    if (!window.matchMedia('(min-width: 1025px)').matches) return;

    var $win = $('.conceptFixed__window');
    var $container = $('.conceptFixed__container');
    if ($win.length === 0 || $container.length === 0) return;

    // fixed時の top と高さ
    var fixedTop = parseFloat(getComputedStyle($win[0]).top) || 0;
    var winH     = $win.outerHeight();
    var scrollTop = $(window).scrollTop();

    // 窓の下端（ページ座標）
    var windowBottomY = scrollTop + fixedTop + winH;

    // 文章ブロックの「下端」を stop とみなす（実測）
    var rect = $container[0].getBoundingClientRect();
    var stopY = rect.bottom + window.pageYOffset+ (window.innerHeight * 0.2);

    // 到達までは 0、到達したら負の値で上にずらし続ける
    var translateY = 0;
    if (windowBottomY > stopY){
      translateY = stopY - windowBottomY; // 負の値
    }

    // 反映
    $win[0].style.transform = 'translateY(' + translateY + 'px)';

    // デバッグ用クラス（任意）
    if (translateY < 0) {
      $win.addClass('is-following');
    } else {
      $win.removeClass('is-following');
    }
  }

  // スクロールはrequestAnimationFrameで間引く（ガタつき防止）
  var ticking = false;
  function onScroll(){
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      updateConceptFollow();
      ticking = false;
    });
  }

  $(window).on('load resize', updateConceptFollow);
  $(window).on('scroll', onScroll);
})(jQuery);



/*
function fixedPageStart(){
  $('.fixedFadeUp').each(function(){
    $(this).addClass('fixedScrollUp');
  });
  
}
*/
function fixedPageStart(){
  $('.fixedFadeUp').not('.conceptFixed__window').each(function(){
    $(this).addClass('fixedScrollUp');
  });
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
  fixedPageStart();
});

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
  fixedPageStart();
});

// テキストを１行ずつふわっと表示

function fadeUpAnime(){
  $('.fadeUpTrigger').each(function(){
    var fadeUpElemPos = $(this).offset().top+100;
    var fadeUpScroll = $(window).scrollTop();
    var fadeUpWindowHeight = $(window).height();
    if (fadeUpScroll >= fadeUpElemPos - fadeUpWindowHeight){
      $(this).addClass('fadeUpOpen');
    }else{
      $(this).removeClass('fadeUpOpen');
    }
  });
}

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
  fadeUpAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function (){
  fadeUpAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面をスクロールをしたら動かしたい場合の記述


// ------------------------------------------
// コンタクトフォーム
// ------------------------------------------
$(function(){
  var Target = $('.custom-form__select');
  $(Target).on('change', function(){
    if ($(Target).val() !== ""){
      $(this).removeClass('is-empty');
      console.log("remove");
    } else {
      $(this).addClass('is-empty');
      console.log("add");
    }
  });
});

// ------------------------------------------
// Productページ 追従ボタンがフッターにかかったら非表示
// ------------------------------------------
$(window).on('load', function() {
    var footer_height = $('#footer').innerHeight(); // footerの高さを取得
  
    window.onscroll = function () {
      var point = window.pageYOffset; // 現在のスクロール地点 
      var docHeight = $(document).height(); // ドキュメントの高さ
      var dispHeight = $(window).height(); // 表示領域の高さ
        
      if(point > docHeight - dispHeight - footer_height){ // スクロール地点>ドキュメントの高さ-表示領域-footerの高さ
        $('.p-target-container .p-target').addClass('is-hidden'); //footerより下にスクロールしたらis-hiddenを追加
      }else{
        $('.p-target-container .p-target').removeClass('is-hidden'); //footerより上にスクロールしたらis-hiddenを削除
      }
    };
});
